// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__8DWfo","half-checked":"Checkbox_half-checked__dBEb3"};